<div>
  <button mat-raised-button *ngIf="showButton" color="primary" (click)="setActive($event)">
    Activate
  </button>
  <div fxFlex *ngIf="!showButton">N/A</div>
</div>